import cx from 'classnames';
import {
  PlateElement,
  PlateElementProps,
} from 'lib-knowledge-document-structure/plate/common';
import {
  // Reminder for when adding resizing
  // useTableCellElementResizable,
  // useTableCellElementResizableState,
  useTableCellElement,
  useTableCellElementState,
} from 'lib-knowledge-document-structure/plate/table';
import {
  MyTableCellElement,
  MyValue,
} from 'lib-knowledge-document-structure/plateTypes';
import { ElementRef, forwardRef } from 'react';

import s from '../baseBlock/block.module.scss';
import { TableActionButton } from './tableActionButton';
import { useCellHover } from './useCellHover';

export interface TableCellElementProps extends PlateElementProps<
  MyValue,
  MyTableCellElement
> {
  hideBorder?: boolean;
  isHeader?: boolean;
}

const TableCellBlock = forwardRef<
  ElementRef<typeof PlateElement>,
  TableCellElementProps
>(({ children, className, hideBorder, isHeader, ...props }, ref) => {
  const { element } = props;
  const { colIndex, rowIndex, selected, rowSize } = useTableCellElementState();
  const { props: cellProps } = useTableCellElement({ element });
  const {
    props: hoverProps,
    showColumnButton,
    showRowButton,
    showColumnMenu,
    showRowMenu,
    isColumnSelected,
    isRowSelected,
  } = useCellHover();

  const Cell = isHeader ? 'th' : 'td';

  return (
    <PlateElement
      asChild
      ref={ref}
      className={cx(
        { [s['cellSelected']]: selected || isColumnSelected || isRowSelected },
        className,
      )}
      {...cellProps}
      {...hoverProps}
      {...props}
    >
      <Cell>
        {showRowButton && (
          <TableActionButton
            element={element}
            type="row"
            rowIndex={rowIndex}
            columnIndex={colIndex}
            showMenu={showRowMenu}
          />
        )}

        {showColumnButton && (
          <TableActionButton
            element={element}
            type="column"
            rowIndex={rowIndex}
            columnIndex={colIndex}
            showMenu={showColumnMenu}
          />
        )}

        <div style={{ minHeight: rowSize }}>{children}</div>
      </Cell>
    </PlateElement>
  );
});
TableCellBlock.displayName = 'TableCellBlock';

const TableCellHeaderBlock = forwardRef<
  ElementRef<typeof TableCellBlock>,
  TableCellElementProps
>((props, ref) => {
  return <TableCellBlock ref={ref} {...props} isHeader />;
});

TableCellHeaderBlock.displayName = 'TableCellHeaderBlock';

export { TableCellBlock, TableCellHeaderBlock };
